const mixin = {
    computed:
    {
      PrimaryColor()
      {
        const {primary} = this.$vuetify.theme.themes.light;
        return primary;
      },
      StylePrimaryColorText()
      {
        const {primary} = this.$vuetify.theme.themes.light;
        return `color: ${primary}`;
      },
      SecondaryColor()
      {
        const {secondary} = this.$vuetify.theme.themes.light;
        return secondary;
      },
      StyleSecondaryColorText()
      {
        const {secondary} = this.$vuetify.theme.themes.light;
        return `color: ${secondary}`;
      }
    }
}

export default mixin;